import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneyElementCommons,
  combineJourneys,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  etktAndFFBoardingPassResult,
  ffSVIdentificationAlshehri,
  journeyElementIds,
  journeys,
  noItemToPayError,
  seatmap,
} from '../../mock/data';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const journeyWithFF = createJourney({
  template: {
    journeyElements: combineJourneyElementCommons([
      createJourneyElementCommon({
        template: {
          ...journeys[0].journeyElements[0],
          journeyElement: createJourneyElement({
            template: {
              ...journeys[0].journeyElements[0].journeyElement,
              frequentFlyerCard: ffSVIdentificationAlshehri
            }
          })
        }
      })
    ]).items
  }
});

const acceptedJourneyWithFF = createJourney({
  template: {
    ...acceptedJourney,
    journeyElements: combineJourneyElementCommons([
      createJourneyElementCommon({
        template: {
          ...journeys[0].journeyElements[0],
          journeyElement: createJourneyElement({
            template: {
              ...journeys[0].journeyElements[0].journeyElement,
              frequentFlyerCard: ffSVIdentificationAlshehri
            }
          })
        }
      })
    ]).items
  }
});

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 * FF added already in PNR
 * Boarding Passes displayed
 */
export const ow1Journey1AdtFFRetrieve: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(etktAndFFBoardingPassResult, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)
  ],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(combineJourneys([journeyWithFF]).items, 201), createMockDataWithResponse([{
      ...journeyWithFF,
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourneyWithFF)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
